import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Examples from './components/Examples';
import WhyUs from './components/WhyUs';
import Contact from './components/Contact';
import Works from './components/Works';
import Wedding from './components/Wedding';
import Wedding2 from './components/Wedding2';
import Graduate from './components/Graduate';
import Footer from './components/Footer';
import Engagement from './components/Engagement';
import Birthday from './components/Birthday';
import Birthday2 from './components/Birthday2';
import Birthday3 from './components/Birthday3';
import Birthday4 from './components/Birthday4';
import Event from './components/Event';

// Ana sayfa bileşeni
const HomePage = () => {
    return (
        <>
            <Header />
            <Hero />
            <Services />
            <Examples />
            <WhyUs />
            <Contact />
        </>
    );
};

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<><HomePage /><Footer /></>} />
                    <Route path="/calismalarimiz" element={<><Works /><Footer /></>} />
                    <Route path="/wedding" element={<><Wedding /><Footer /></>} />
                    <Route path="/wedding2" element={<Wedding2 />} />
                    <Route path="/graduate" element={<><Graduate /><Footer /></>} />
                    <Route path="/engagement" element={<Engagement />} />
                    <Route path="/birthday" element={<Birthday />} />
                    <Route path="/birthday2" element={<Birthday2 />} />
                    <Route path="/birthday3" element={<Birthday3 />} />
                    <Route path="/birthday4" element={<Birthday4 />} />
                    <Route path="/event" element={<Event />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;